import React, { useRef, useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const brands = [
  {
    name: 'Bebi Born',
    color: '#8B5A6B',
    logo: '/logos/bebi_born_canvas.png',
    url: 'https://www.amazon.fr/-/en/stores/BEBIBORN/page/5AED077F-E948-4CAF-AD0A-2ED330E166E3?lp_asin=B08PPXDDTB&ref_=ast_bln',
  },
  {
    name: 'Clever Camper',
    color: '#5E6B4E',
    logo: '/logos/clever_camper_canvas.png',
    url: 'https://www.amazon.com/stores/CleverCamperCompany/page/DCBB878E-5AFA-4936-9BAA-7535A2C1370F?lp_asin=B08DGB22PC&ref_=ast_bln',
  },
  {
    name: 'Shafi Cables',
    color: '#3A6B7C',
    logo: '/logos/shafi_canvas.png',
    url: 'https://www.amazon.co.uk/stores/SHAFIHighQualityPowerCables/page/4DD05481-10CF-409B-89F6-E103AC226AE4',
  },
  {
    name: 'Solawell',
    color: '#9B7653',
    logo: '/logos/solawell_canvas.png',
    url: 'https://www.amazon.com/stores/SOLAWELL/page/043F0D4E-DABC-4E30-A962-C8C294C4D5F4?lp_asin=B08X4WG488&ref_=ast_bln&store_ref=bl_ast_dp_brandLogo_sto',
  },
  {
    name: 'Reelleo',
    color: '#7B5E74',
    logo: '/logos/reelleo_canvas.png',
    url: 'https://www.amazon.fr/stores/page/042F5A08-8E2E-41ED-AA22-631B982752C3?ingress=0&visitId=c9995792-8206-4f9d-907b-7eb21790c6b1',
  },
  {
    name: 'Western Essence',
    color: '#B46A52',
    logo: '/logos/western_essence_canvas.png',
    url: 'https://www.amazon.com/Western-Southwestern-American-Multicolor-Bedspread/dp/B075V3Z34Y/ref=sr_1_5?crid=2MOE6DVJORALW&dib=eyJ2IjoiMSJ9.jiD0K9ODzIr95gfy3rmzQLQpUSvo7hwA5C3ZNqclH5aGJ5Mkc8nBlK4ITJWd31CdweOLOElIvDpfU7T3YeQ4uVR_VkfsWeK3T24dswytgtsKIuHI1eY4z4vM1UzDwud6lLzJkrkXbvBsPma15rWMMV45v90Xb6MhQzew6kL-tARl9TtVt3OMG4Dd6c78t-1CgRWETqdF2zb-EKRlatFy2vpgjtZwRdXKR3gX9KLp6JQB5BWkRUiaCYV1peosJuHFS7rVlNeujnX6rriC-HYzkII-m-X2B8tKD_3CVw-1VWo.7dwN32DyQCABxwTskaHkfiQ3DWcy6jXoUyGbPfpwwR0&dib_tag=se&keywords=Western+essence+bedding+set&qid=1786625729&sprefix=western+essence+bedding+se%2Caps%2C379&sr=8-5',
  },
  {
    name: 'Dream Haven',
    color: '#5D718A',
    logo: '/logos/dream_haven_canvas.png',
    url: 'https://www.amazon.it/DREAM-Antirussamento-Antireflusso-Anallergica-Ergonomico/dp/B0DHVK666S/ref=sr_1_1?__mk_it_IT=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3BNYOLEQ0CMJX&dib=eyJ2IjoiMSJ9.lZgbNsBKHNiqVOBYbahWZ205WWSr5Jvbc6JVk7SlExbtLomuoPkPFCRhNZ4TjXnOHdmnjUOyQPfz91RJHptaVBk9qTacgLj3ELRF6spyGYhIe_ZrrQ45KSLTIEoYb9nttvCA0I6ZPw1fEVVc64X9Sf2tSJWMqLCJarIs7emHWRFtpPtwx8rhq4UelZJX0qKaARQd_Fb_O3D8WJPtC5vbKTEQldHFmAJ5BhbNxwFYgBgZKPWJGO6GD0m_SGEn0Et1n_VDCaul8Bcwzmw9XBPcgzjS9Yn_LbMpf0yFVepsEng.9SCMBwHVQtlwhBdmbloD0VKFG8_c4DjkWma-pwz6Kfw&dib_tag=se&keywords=Dream%2BHaven&qid=1786622155&sprefix=dre%2Caps%2C458&sr=8-1&th=1',
  },
  {
    name: 'Simplify Asthetic',
    color: '#7B5E74',
    logo: '/logos/simplify_canvas.png',
    url: 'https://www.amazon.com/stores/SIMPLIFYASTHETIC/page/BDCB52EC-C941-47FC-9BCB-8A238FD0BA72?lp_asin=B0CF7J6DP5&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto',
  },
  {
    name: 'Aheal',
    color: '#5F7663',
    logo: '/logos/aheal_canvas.png',
    url: 'https://www.amazon.de/stores/aHeal/page/33098CC4-6817-49C5-B69A-BB860460A3EE?lp_asin=B07F3FT7DY&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto&bl_grd_status=override',
  },
  {
    name: 'Owlcraft',
    color: '#A88A4A',
    logo: '/logos/owlcraft_canvas.png',
    url: 'https://www.amazon.com/stores/page/D53EBF4E-991D-44A1-B10C-C60361B004FE?ingress=2&lp_context_asin=B0H44YMK7J&visitId=6ef3dbec-8ac7-41ca-ac2c-ad81773650be&store_ref=bl_ast_dp_brandlogo_sto&ref_=ast_bln',
  },
];

// ── Auto-scroll speed: 120 px/s (1.5× old 80 px/s baseline) ──
const AUTO_PX_PER_S = 120;

const BrandStrip = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Drag state
  const isDragging = useRef(false);
  const hasMoved = useRef(false);
  const dragStart = useRef({ x: 0, scrollLeft: 0 });

  // Auto-scroll state
  const rafRef = useRef(null);
  const lastTsRef = useRef(null);
  const isPaused = useRef(false);   // true when user hovers / drags / touches
  const halfRef = useRef(0);        // width of one brand set (for seamless reset)

  // Duplicate brands for seamless infinite loop
  const loopBrands = [...brands, ...brands];

  /* ── Measure the single-set width after first paint ── */
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    requestAnimationFrame(() => {
      // The card at index brands.length is the first card of the duplicate set.
      // Its offsetLeft is exactly one full set width (including left padding + gaps).
      const cards = el.querySelectorAll('[data-brand-card]');
      const pivot = cards[brands.length];
      if (pivot) halfRef.current = pivot.offsetLeft;
    });
  }, []);

  /* ── Arrow visibility ── */
  const updateArrows = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    // With looping content there's always more on the right
    setCanScrollRight(true);
  }, []);

  /* ── rAF auto-scroll loop ── */
  const tick = useCallback((ts) => {
    const el = scrollRef.current;
    if (el) {
      if (!isPaused.current && !isDragging.current) {
        if (lastTsRef.current !== null) {
          const dt = Math.min((ts - lastTsRef.current) / 1000, 0.05); // cap delta at 50ms
          el.scrollLeft += AUTO_PX_PER_S * dt;
          // Seamless reset: when we've scrolled past the first set, jump back
          if (halfRef.current > 0 && el.scrollLeft >= halfRef.current) {
            el.scrollLeft -= halfRef.current;
          }
        }
      }
      lastTsRef.current = ts;
    }
    rafRef.current = requestAnimationFrame(tick);
  }, []);

  /* ── Scroll by one card on arrow click (pauses briefly) ── */
  const scrollByCard = useCallback((dir) => {
    isPaused.current = true;
    scrollRef.current?.scrollBy({ left: dir * 240, behavior: 'smooth' });
    // Resume auto-scroll after 2.5 s
    setTimeout(() => { isPaused.current = false; lastTsRef.current = null; }, 2500);
  }, []);

  /* ── Mouse drag ── */
  const onMouseDown = useCallback((e) => {
    if (e.button !== 0) return;
    const el = scrollRef.current;
    if (!el) return;
    isDragging.current = true;
    hasMoved.current = false;
    dragStart.current = { x: e.clientX, scrollLeft: el.scrollLeft };
    el.style.cursor = 'grabbing';
    e.preventDefault();
  }, []);

  const onMouseMove = useCallback((e) => {
    if (!isDragging.current || !scrollRef.current) return;
    const dx = e.clientX - dragStart.current.x;
    if (Math.abs(dx) > 4) hasMoved.current = true;
    scrollRef.current.scrollLeft = dragStart.current.scrollLeft - dx;
  }, []);

  const onDragEnd = useCallback(() => {
    if (!scrollRef.current) return;
    isDragging.current = false;
    scrollRef.current.style.cursor = 'grab';
    // Brief pause after drag before resuming
    isPaused.current = true;
    setTimeout(() => { isPaused.current = false; lastTsRef.current = null; }, 1000);
  }, []);

  /* ── Prevent accidental link open on drag ── */
  const guardClick = useCallback((e) => {
    if (hasMoved.current) e.preventDefault();
  }, []);

  /* ── Mount / cleanup ── */
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    window.addEventListener('mouseup', onDragEnd);
    // Start auto-scroll loop
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      el.removeEventListener('scroll', updateArrows);
      window.removeEventListener('mouseup', onDragEnd);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [updateArrows, onDragEnd, tick]);

  return (
    <section id="our-brands" className="py-24 md:py-32 bg-[#F5F0EB]">
      {/* Section heading */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4D3E] mb-4"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}
        >
          Our boring portfolio.
        </h2>
        <p className="text-lg text-[#2C2C2C]">
          These are the brands we're proud to own and operate.
        </p>
      </div>

      {/* Outer div clips overflow → no page-level horizontal scroll */}
      <div className="overflow-x-hidden">
        <div
          className="relative max-w-7xl mx-auto"
          onMouseEnter={() => { isPaused.current = true; }}
          onMouseLeave={() => { isPaused.current = false; lastTsRef.current = null; }}
        >
          {/* Left navigation arrow — desktop only */}
          <button
            onClick={() => scrollByCard(-1)}
            aria-label="Scroll left"
            className={[
              'hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10',
              'w-9 h-9 items-center justify-center rounded-full',
              'bg-[#F5F0EB] border border-[#1B4D3E]/20 text-[#1B4D3E]',
              'shadow-sm hover:bg-white transition-all duration-200',
              canScrollLeft ? 'opacity-100' : 'opacity-0 pointer-events-none',
            ].join(' ')}
          >
            <ChevronLeft className="w-4 h-4" strokeWidth={2.5} />
          </button>

          {/* ── Scrollable track ── */}
          <div
            ref={scrollRef}
            className="no-scrollbar flex gap-5 overflow-x-auto px-6 md:px-12 select-none"
            style={{ cursor: 'grab', WebkitOverflowScrolling: 'touch' }}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onDragEnd}
            onTouchStart={() => { isPaused.current = true; }}
            onTouchEnd={() => {
              setTimeout(() => { isPaused.current = false; lastTsRef.current = null; }, 1500);
            }}
          >
            {loopBrands.map((brand, i) => {
              const cardStyle = { backgroundColor: brand.color, padding: '20px 20px 16px 20px' };
              const cardClass =
                'w-[220px] flex-shrink-0 flex flex-col items-center rounded-xl shadow-sm ' +
                'transition-all duration-200 ease-out';

              const inner = (
                <>
                  <div className="w-[180px] mb-3">
                    <img
                      src={brand.logo}
                      alt={`${brand.name} logo`}
                      className="w-full h-auto"
                      draggable={false}
                    />
                  </div>
                  <h3
                    className="text-lg font-bold text-white text-center"
                    style={{ fontFamily: 'Space Grotesk, sans-serif' }}
                  >
                    {brand.name}
                  </h3>
                </>
              );

              return brand.url ? (
                <a
                  key={i}
                  data-brand-card
                  href={brand.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${cardClass} hover:shadow-lg hover:scale-[1.03] cursor-pointer`}
                  style={cardStyle}
                  draggable={false}
                  onClick={guardClick}
                >
                  {inner}
                </a>
              ) : (
                <div
                  key={i}
                  data-brand-card
                  className={cardClass}
                  style={cardStyle}
                  draggable={false}
                >
                  {inner}
                </div>
              );
            })}
          </div>

          {/* Right navigation arrow — desktop only */}
          <button
            onClick={() => scrollByCard(1)}
            aria-label="Scroll right"
            className={[
              'hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10',
              'w-9 h-9 items-center justify-center rounded-full',
              'bg-[#F5F0EB] border border-[#1B4D3E]/20 text-[#1B4D3E]',
              'shadow-sm hover:bg-white transition-all duration-200',
              canScrollRight ? 'opacity-100' : 'opacity-0 pointer-events-none',
            ].join(' ')}
          >
            <ChevronRight className="w-4 h-4" strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BrandStrip;
